import * as main from './main.js';
import * as compass from './ui/compass.js';
import * as scene from './scene.js';
import * as player from './player.js';
import { dirToRad, degToRad } from './utils.js';
import * as loader from './loader.js';

export {
    init,
    getCanvas,
    draw,
}

let canvas;
let ratio;
let pixelsPerMeter;

function init () {
    ratio = scene.config.worldSize.width / scene.config.worldSize.height;
    pixelsPerMeter = main.config.width / scene.config.worldSize.width;

    canvas = document.createElement('canvas');
    canvas.className = 'map';
    canvas.width = main.config.width;
    canvas.height = main.config.height * 1/ratio;
}

function getCanvas() {
    return canvas;
}

function draw () {
    // Draw the map
    const ctx = canvas.getContext('2d');

    // Clear the canvas
    ctx.fillStyle = 'black';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Draw the point field
    // TODO: Think and move compass.config.pointSeparation and compass.config.pixelsPerMeter to scene ?
    const pointsInterval = canvas.width / scene.config.worldSize.width * compass.config.pointSeparation;
    ctx.fillStyle = '#222';
    for (let x = 0; x <= canvas.width; x += pointsInterval) {
        for (let y = 0; y <= canvas.height; y += pointsInterval) {
            ctx.fillRect(x - 0.75, y - 0.75, 1.5, 1.5);
        }
    }

    // TODO: review the transforms here and apply same strategy to compass draws + try to generalize draws ?

    ctx.save();
    ctx.translate(scene.config.worldOrigin.x * pixelsPerMeter, scene.config.worldOrigin.y * pixelsPerMeter);

    drawPOIs(ctx);
    drawPlayer(ctx);

    ctx.restore();

    // TODO: drawFogOfWar(ctx);
}

function drawPlayer(ctx) {
    const playerX = player.position.x * pixelsPerMeter;
    const playerY = player.position.y * pixelsPerMeter;

    // Add translate and rotate to the transformation matrix for world coordinates
    // TODO: convert all other draws with initial transforms then local coordinates like this method
    ctx.save();
    ctx.translate(playerX, playerY);
    ctx.rotate(degToRad(player.direction));

    // Draw player
    ctx.beginPath();
    ctx.arc(0, 12, 8, dirToRad(0) - degToRad(45), dirToRad(0) + degToRad(45));
    ctx.lineTo(0, -8);
    ctx.closePath();

    ctx.fillStyle = 'white';
    ctx.fill();

    // Restore transformation matrix to canvas coordinates
    ctx.restore();
}

function drawPOIs(ctx) {
    const compassToMapRatio =  pixelsPerMeter / compass.config.pixelsPerMeter;

    // TODO: filter out POIs that are still in fog of war
    const visiblePOIs = scene.POIs.filter(p => !p.invisible);
    for (const p of visiblePOIs) {
        if (p.hideOnMap) continue;

        const poiX = p.position.x * pixelsPerMeter;
        const poiY = p.position.y * pixelsPerMeter;

        ctx.save();
        ctx.translate(poiX, poiY);
        ctx.rotate(degToRad(p.rotation));
        ctx.scale(compassToMapRatio, compassToMapRatio);
        if (p.symbolic !== false) ctx.scale(2, 2); // Make it a bit bigger for the map

        ctx.fillStyle = p.color;
        ctx.beginPath();
        if (p.image) {
            // Draw image
            const imageWidth = loader.images[p.image].width;
            const imageHeight = loader.images[p.image].height;
            ctx.drawImage(
                loader.images[p.image],
                -imageWidth/2,
                -imageHeight/2,
                imageWidth,
                imageHeight,
            );
        } else if (p.type === 'triangle') {
            // Draw a triangle centered on p.position
            ctx.beginPath();
            ctx.moveTo(Math.cos(degToRad(150)) * p.radius, Math.sin(degToRad(150)) * p.radius);
            ctx.lineTo(0, -p.radius);
            ctx.lineTo(Math.cos(degToRad(30)) * p.radius, Math.sin(degToRad(30)) * p.radius);
            ctx.closePath();
        } else if (p.type === 'circle' || !p.type) {
            // Draw circle (default type)
            ctx.arc(
                0,
                0,
                p.radius || 5,
                0,
                Math.PI * 2
            );
        }

        // Handling for styled shapes
        if (!p.image) {
            if (!p.style) {
                ctx.fill();
            } else if (p.style === 'idle') {
                ctx.fillStyle = '#99b';
                ctx.strokeStyle = '#99b';
                ctx.lineWidth = 1;
                ctx.fill();
                ctx.stroke();
            } else if (p.style === 'active') {
                const timebase = Math.abs(Math.sin(Math.floor(Date.now() / 3 % 1000) / 1000 * Math.PI * 2));
                ctx.strokeStyle = p.color.replace('50%', `${timebase * 30 + 50}%`);
                ctx.lineWidth = 2;
                ctx.fill();
                ctx.stroke();
            }
        }
        ctx.restore();
    }

    // Draw Grudge path points as question marks
    const grudge = scene.POIs.find(p => p.name === 'grudge');
    for (const point of grudge.wander.points) {
        ctx.save();
        ctx.translate(point.x * pixelsPerMeter, point.y * pixelsPerMeter);
        ctx.font = '15px Helvetica Neue';
        ctx.fillStyle = '#666';
        ctx.fillText('?', 0, 0);
        ctx.restore();
    }
}